import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { CardType } from '../../../../types/cardType';
import { getPaySystemName } from '../../../../utils/cashier';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import PaymentTitles from '../../../PaymentTitles/PaymentTitles';

import { TXTCLI_Confirm_Details } from './DepositDetailsConfirm.messages.json';
import ECheckConfirm from './components/ECheckConfirm/ECheckConfirm';

const paySystemDetailsConfirm: Partial<Record<CardType, JSX.Element>> = {
  [CardType.ECheck]: <ECheckConfirm />
};

const DepositDetailsConfirm: React.FC = () => {
  const {
    values: {
      deposit: { type }
    },
    data: { paySystems }
  } = useWizardContext();

  const systemName = getPaySystemName(paySystems, type);

  return (
    <Container
      page={DepositDetailsConfirm}
      headerProps={{ title: systemName }}
      helpSupportResolver
      showFooter
    >
      <PaymentTitles type={type} systemName={systemName} showSafeInfo useConfirmTitle />
      <fieldset>{paySystemDetailsConfirm[type]}</fieldset>
      <CTAButton translation={TXTCLI_Confirm_Details} />
    </Container>
  );
};

DepositDetailsConfirm.displayName = 'DepositDetailsConfirm';

export default DepositDetailsConfirm;
